import { render, staticRenderFns } from "./QuickSummary.vue?vue&type=template&id=6a2bc103&scoped=true&"
import script from "./QuickSummary.vue?vue&type=script&lang=js&"
export * from "./QuickSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2bc103",
  null
  
)

export default component.exports